import { render, staticRenderFns } from "./HeatOrCombi.vue?vue&type=template&id=20d5f3f9"
import script from "./HeatOrCombi.vue?vue&type=script&lang=ts"
export * from "./HeatOrCombi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports